export const TOOLTIP_SURFACE_BG = "#0f172a";
export const TOOLTIP_SURFACE_RADIUS = 4;
export const TOOLTIP_SURFACE_SHADOW = "0 4px 14px rgba(15,23,42,0.22)";

export const tooltipSurfaceSx = {
  bgcolor: TOOLTIP_SURFACE_BG,
  borderRadius: TOOLTIP_SURFACE_RADIUS,
  boxShadow: TOOLTIP_SURFACE_SHADOW,
  color: "#fff",
};
